import Vue from 'vue'
// 通用格式化orderStatus
Vue.filter('resolveOrderStatusText', orderStatus => {
  switch (orderStatus) {
    case 0:
      return '待付款'
    case 1:
      return '支付成功'
    case 2:
      return '已取消'
    case 3:
      return '已取消'
    case 4:
      return '待收货'
    case 5:
      return '已退费'
    case 6:
      return '发货中'
    case 7:
      return '支付中'
    case 8:
      return '待发货'
    case 9:
      return '订单未成功'
    case 10:
      return '退费中'
    case 11:
      return '待收货'
    case 12:
      return '售后中'
    case 13:
      return '已完成'
    case 14:
      return '已关闭'
    case 15:
      return '待分享'
    case 16:
      return '已关闭'
    default:
      return ''
  }
})
